import React from 'react'
import { useCallback, useMemo } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import actions from 'redux/actions'

import Box from 'components/_new/layout/Box/Box'
import FixedSidebar from 'components/_new/FixedSidebar/FixedSidebar'
import NavList from 'components/_new/NavList/NavList'
import useCanUsePrepaidPlans from 'components/upgradePlans/useCanUsePrepaidPlans'

import PersonalInfo from './PersonalInfo/PersonalInfo'
import QueueSection from './QueueSection/QueueSection'

import { getNav } from './util/index'
import s from './SidebarProfileNav.scss'


const SidebarProfileNav = () => {
  const { isOpened, isUndeliverable, isCancelled, isUpgradable, isPaused, pathname } = useConnect({
    isOpened: 'models.ui.isProfileMenuVisible',
    isUndeliverable: 'models.subscription.isUndeliverable',
    isCancelled: 'models.subscription.isCancelled',
    isUpgradable: 'models.subscription.isUpgradable',
    isPaused: 'models.subscription.isPaused',
    pathname: 'routing.location.pathname',
  })

  const isPrepaidPlansLandingPageEnabled = useCanUsePrepaidPlans()

  const close = useCallback(() => {
    actions.models.ui.closeProfileMenu()
  }, [])

  const nav = useMemo(
    () => getNav({ isUndeliverable, isCancelled, isUpgradable, isPaused, isPrepaidPlansLandingPageEnabled }),
    [ isUndeliverable, isCancelled, isUpgradable, isPaused, isPrepaidPlansLandingPageEnabled ]
  )

  return (
    <FixedSidebar className={s.sideMenu} isOpened={isOpened} position="right">
      <PersonalInfo closeMenu={close} />
      <QueueSection closeMenu={close} />
      <Box pt="36" pb="24">
        <NavList items={nav} pathname={pathname} closeNav={close} />
      </Box>
    </FixedSidebar>
  )
}


export default SidebarProfileNav
